import React from 'react';

export class Search extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: '',
			results: null,
			showCloseIcon: false,
			typingTimeout: null
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSelectionClick = this.handleSelectionClick.bind(this);
		this.handleCloseClick = this.handleCloseClick.bind(this);
	}

	handleChange(e) {
		const self = this;
		if (self.state.typingTimeout) {
			clearTimeout(self.state.typingTimeout);
		}

		if (e.target.value === '') {
			this.handleCloseClick()
		} else {
			this.setState({
				value: e.target.value,
				typingTimeout: setTimeout(function () {
						self.handleSubmit(null);
				}, 750)
			});
		}
	}

	handleSubmit(e) {
		if (e) {
			e.preventDefault();
		}

		let search_with_city = '';
		if (!(this.props.city.startsWith('NRW'))) {
			search_with_city = this.props.city
		}
		fetch('https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=10&countrycodes=de&q=' + this.state.value + ' ' + search_with_city)
			.then(res => res.json())
			.then(json => {
				let results = [];
				let already_in = [];
				json.forEach(result => {
					let main, sub;
					let subsub = "";
					if (["building", "amenity", "place"].includes(result.class)) {
						main = ""
						if (result.class in result.address) {
							main = result.address.[result.class] + ", "
						}
						main += result.address.road
						if ("house_number" in result.address) {
							main += " " + result.address.house_number
						}

					} else if (result.class === "highway") {
						main = result.address.road
					} else if (result.class === "boundary") {
						main = result.address.city
					} else {
						main = result.address.[result.class]
					}

					if ("suburb" in result.address) {
						sub = result.address.suburb
						if ("city" in result.address) {
							subsub = result.city
						}
					} else if ("city_district" in result.address) {
						sub = result.address.city_district
						if ("city" in result.address) {
							subsub = result.city
						}
					} else if ("city" in result.address) {
						sub = result.address.city
					} else {
						sub = ""
					}

					if (!already_in.includes(main + sub) 
							&& (this.props.city.startsWith('NRW') || result.address.city === this.props.city)
							&& result.address.state === "Nordrhein-Westfalen"
							&& already_in.length < 5 
							&& main
							&& main !== "undefined") {
							//&& !["boundary"].includes(result.class)) {
						already_in.push(main + sub)
						results.push({
							'lat': result.lat,
							'lon': result.lon,
							'main': main,
							'sub': sub,
							'subsub': subsub
						})
					}

				})
				this.props.removeBezirkLine();
				this.setState({
					results: results,
					showCloseIcon: true,
					typingTimeout: null
				})
			})
	}

	handleCloseClick() {
		this.setState({
			value: '',
			results: null,
			showCloseIcon: false,
			typingTimeout: null
		})
	}

	handleSelectionClick(coordinates, text) {
		this.setState({
			value: text,
			results: null,
			showCloseIcon: true
		}, this.props.handleAdressClick(coordinates))
	}

	render() {
		return (
			<>
				<form onSubmit={this.handleSubmit}>
					<div className="searchDiv rounded">
						<input 
							id="wahlkarteSearch"
							className={"border " + (this.state.results ? "rounded-top-left" : "rounded-left")}
							type="text" 
							placeholder="Geben Sie Ihre Adresse ein ..." 
							value={this.state.value} 
							onChange={this.handleChange}
							autocomplete="off"
						/>
						<div 
							className={"border search-icon " + (this.state.results ? "rounded-top-right" : "rounded-right")}
							onClick={this.handleCloseClick} 
						>
							{this.state.typingTimeout
								?
									<div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
								:
									this.state.showCloseIcon
										?
											<b>×</b>
										:
											<img 
												alt="X-Icon"
												src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABD0lEQVRIie2UPW7CQBCFP5IS0gEnoQdyAxAHSQoUUSD+Gm4DIiegoITkAOEMJIQWTDFvwY3xrqFAUZ402rX95r2xvTPwV1EGRsAHsFOsgCFQula8BWyBKCF+gOY14gcJTYAqkFfUgKme7YFGqHg5Vnn7Au9NnG+gGGIw4lx5GmbiDkIMPpVU9eDWxV2FGPwqqeDBfRJ3m0Z8iO2jgGJyvsS4wVprxSPPcb5CDN61vngYvGqdeXBPKGFNFGFHMQkdcTZk6Oom1kSRqqtjP70APGNv6Tq6Gyru0MCaKGlUbCTurvtZTIpYEy2x47vTfsD5s8RNM5mkwY0MF+N/k7sy6bmbjzc0WGAzak7gGL9vHAG+Ol6n6x8u5AAAAABJRU5ErkJggg=="
											/>
							}
						</div>
					</div>
				</form>
				{this.state.results
					&&
						<div className="border rounded-bottom searchResults">
							{this.state.results.length
								?
									this.state.results.map(res => (
										<div className="selectable" onClick={() => this.handleSelectionClick([parseFloat(res.lon), parseFloat(res.lat)], res.main + ", " + res.sub)}>
											<p>
												<b>{res.main}</b> {res.sub} {res.subsub}		
											</p>
										</div>
									))
								:
									<div>
										<p>
											<i>Keine Suchergebnisse gefunden</i>
										</p>
									</div>
							}
						</div>
				}
			</>
		)
	}
}